var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9111 5.17415C14.3777 5.70755 14.111 5.97425 13.7796 5.97425C13.4482 5.97425 13.1815 5.70755 12.6481 5.17415L10.8283 3.35432C10.2949 2.82092 10.0282 2.55422 10.0282 2.22281C10.0282 1.8914 10.2949 1.6247 10.8283 1.0913L11.1171 0.802537C11.6505 0.26914 11.9172 0.00244139 12.2486 0.00244141C12.58 0.00244142 12.8467 0.26914 13.3801 0.802538L15.1999 2.62237C15.7333 3.15577 16 3.42247 16 3.75388C16 4.08529 15.7333 4.35199 15.1999 4.88539L14.9111 5.17415Z",
    fill: "#868FA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60019 16.0024C0.845854 16.0024 0.468685 16.0024 0.234343 15.7681C0 15.5337 0 15.1566 0 14.4022V12.5824C0 12.2554 0 12.0918 0.0609037 11.9448C0.121807 11.7978 0.237434 11.6821 0.468686 11.4509L7.54455 4.37503C8.07794 3.84163 8.34464 3.57493 8.67605 3.57493C9.00746 3.57493 9.27416 3.84163 9.80756 4.37503L11.6274 6.19487C12.1608 6.72826 12.4275 6.99496 12.4275 7.32637C12.4275 7.65778 12.1608 7.92448 11.6274 8.45788L4.55153 15.5337C4.32028 15.765 4.20466 15.8806 4.05762 15.9415C3.91059 16.0024 3.74707 16.0024 3.42003 16.0024H1.60019Z",
    fill: "#868FA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c65f2934.svg";
export { ForwardRef as ReactComponent };